import API from "../global/api";
import {
  generateInvoiceLedgerPdf,
  generateInvoiceLedgerExcel,
} from "../Screens/ledgerReports/printFunctions";

// Get Invoice Summary
export const printingInvoiceReportRequest = () => {
  return {
    type: "PRINT_INVOICE_LEDGER_REPORT_REQUEST",
  };
};
export const printingInvoiceReportSuccess = (data) => {
  return {
    type: "PRINT_INVOICE_LEDGER_REPORT_SUCCESS",
    payload: data,
  };
};
export const printingInvoiceReportError = (msg) => {
  return {
    type: "PRINT_INVOICE_LEDGER_REPORT_ERROR",
    payload: msg,
  };
};
export const printingInvoiceReport = (
  data,
  type,
  onClose,
  setFormData,
  handleVisibleForEdit,
  handleDangerVisible,
  modalDetails,
) => {
  return (dispatch) => {
    dispatch(printingInvoiceReportRequest());
    API.post(`/invoice/invoice-summary`, data)
      .then(async (res) => {
        let printingInvoiceReportDataList = res.data;
        if (printingInvoiceReportDataList?.data?.length === 0) {
          handleDangerVisible("No Data Found");
          dispatch(printingInvoiceReportSuccess(printingInvoiceReportDataList));
        } else {
          if (type === "PDF") {
            await generateInvoiceLedgerPdf(
              printingInvoiceReportDataList?.data,
              modalDetails,
            ).then(() => {
              handleVisibleForEdit(
                "PDF Created & Ready to Download Successfully",
                () => {
                  onClose();
                  setFormData({
                    startDate: "",
                    endDate: "",
                    companyId: "",
                  });
                  dispatch(
                    printingInvoiceReportSuccess(printingInvoiceReportDataList),
                  );
                },
              );
            });
          }
          if (type === "EXCEL") {
            generateInvoiceLedgerExcel(
              printingInvoiceReportDataList?.data,
              modalDetails,
            );
            handleVisibleForEdit("Downloaded Successfully", () => {
              onClose();
              setFormData({
                startDate: "",
                endDate: "",
                companyId: "",
              });
              dispatch(
                printingInvoiceReportSuccess(printingInvoiceReportDataList),
              );
            });
          }
        }
      })
      .catch((error) => {
        dispatch(printingInvoiceReportError(error?.response?.data?.message));
        handleDangerVisible(error?.response?.data?.message);
      });
  };
};
